export default __webpack_public_path__ + "static/media/imgRacingFlag.bd63fb4c.png";